import {
  RESET_SELECTED_REQUEST_IN_STORE,
  SET_SELECTED_REQUEST_IN_STORE,
} from '../../actions/types';

const INITIAL_STATE = {};

const pricingRequests = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_REQUEST_IN_STORE: {
      //   const { source, data } = action.data;
      return {
        ...action.data,
      };
    }
    case RESET_SELECTED_REQUEST_IN_STORE: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};

export default pricingRequests;
